import config from '@/config.js'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('featureToggles', ['canUseNewResizeImageApi']),
  },
  methods: {
    async handleResizeImageWithLambda(imageUrl, options = {}) {
      const croppedImage = imageUrl.split('?')[0]
      const extension = croppedImage.split('.').pop()
      return this.$http.post(config.api.resizeImageWithLambda, {
        extension,
        imageUrl,
        ...options,
      })
    },
  },

}
